(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["size-guide"]) return;
  try {
    
$(document).ready(function () {
	$('[href="#size-guide"]').click(function() {
		$('#size-guide').show()
		$('body').css('overflow', 'hidden')
	})

	$('.size-guide-overlay').click(function () {
		$('#size-guide').hide()
        $('body').css('overflow', 'auto')
	})
})

  } catch(e) { console.error(e); }
})();
})();
